
const d3 = require('d3')
const moment = require('moment');

exports.createHrvRMSSD_PulseChart = (rawData, width, height) => {
  const PULSE_RATE_COLOR = '#3D9ADA';
  const RMSSD_COLOR = '#E34040';
  let MAX_RMSSD_VAL = 0;
  let MAX_PULSE_RATE_VAL = 0;
  const parseDate = d3.utcParse('%Y-%m-%d');
  const formatChange = () => {
    const f = d3.format('+.2%');
    return (y0, y1) => f((y1 - y0) / y0);
  };
  const formatValue = d3.format('.2f');
  const formatDate = d3.utcFormat('%B %-d, %Y');
  const data = rawData.map((d, i) => {
    const date = moment(d['timestamp']).utcOffset(0);
    const { rmsdd, pulseRate } = d;
    if (rmsdd > MAX_RMSSD_VAL) MAX_RMSSD_VAL = rmsdd;
    if (pulseRate > MAX_PULSE_RATE_VAL) MAX_PULSE_RATE_VAL = pulseRate;
    return {
      date,
      rmssd: rmsdd,
      pulseRate,
    };
  });
  const MAX_RMSSD = MAX_RMSSD_VAL || 120;
  const MIN_RMSSD = 0;
  const MAX_PULSE_RATE = MAX_PULSE_RATE_VAL || 240;
  const MIN_PULSE_RATE = 0;

  let startOfDay, endOfDay;
  if (data[0]) {
    startOfDay = +moment(data[0].date).startOf('day').toDate()
    endOfDay = +moment(startOfDay).add(24, 'hours').toDate() + 1
  } else {
    startOfDay = +moment(+new Date()).subtract(24, 'hours').toDate();
    endOfDay = +new Date();
  }
  const margin = { top: 70, right: 70, bottom: 40, left: 50 };
  const x = d3
    .scaleTime()
    .domain(
      [startOfDay, endOfDay]
    )
    .range([margin.left - 10, width - margin.right - 5]);
  // .padding(0.4);
  const y_pulseRate = d3
    .scaleLinear()
    .domain([MIN_PULSE_RATE, MAX_PULSE_RATE])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const y_RMSSD = d3
    .scaleLinear()
    .domain([MIN_RMSSD, MAX_RMSSD])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g
      .attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(
        d3
          .axisBottom(x)
          .ticks(25)
          .tickValues(
            d3.utcHour
              .every(1)
              .range(startOfDay, endOfDay)
          )
          .tickFormat((d) => {
            return moment(d).utcOffset(0).format('HH:mm');
          })
          .tickPadding(15)
          .tickSize(0)
      )
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom + 3})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis_pulseRate = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(
        d3
          .axisLeft(y_pulseRate)
          .tickValues(d3.scaleLinear().domain(y_pulseRate.domain()).ticks())
          .tickSize(0)
          .tickPadding(10)
      )
      .call((g) =>
        g
          .selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right + 5)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis_RMSSD = (g) =>
    g
      .attr('transform', `translate(${width - margin.left - 20},0)`)
      .call(
        d3.axisRight(y_RMSSD).tickValues(d3.scaleLinear().domain(y_RMSSD.domain()).ticks()).tickSize(0).tickPadding(10)
      )
      .call((g) => g.select('.domain').remove());

  const pulseRateLineGenerate = d3
    .line()
    .defined((d) => {
      return d.pulseRate && +new Date(d.date) <= moment(startOfDay).add(24, 'hours').toDate();
    })
    .x((d) => x(d.date))
    .y((d) => y_pulseRate(d.pulseRate));

  const RMSSD_LineGenerate = d3
    .line()
    .defined((d) => {
      return d.rmssd && +new Date(d.date) <= moment(startOfDay).add(24, 'hours').toDate();
    })
    .x((d) => x(d.date))
    .y((d) => y_RMSSD(d.rmssd));

  const svg = d3.create('svg').attr('width', width).attr('height', height);

  const pulseRateLine = svg
    .append('path')
    .attr('d', pulseRateLineGenerate(data))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke', PULSE_RATE_COLOR);

  const RMSSD_Line = svg
    .append('path')
    .attr('d', RMSSD_LineGenerate(data))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(0,0)`)
    .attr('stroke', 'red');

  svg.append('g').call(xAxis); //.selectAll('.tick text'); //.call(wrap, x.bandwidth());

  svg.append('g').call(yAxis_pulseRate);
  svg.append('g').call(yAxis_RMSSD);

  const yAxisPulseRateLabel = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 30)
    .style('font-size', '18px')
    .attr('font-weight', '100')
    .text('Pulse Rate');
  const yAxisPulseRateLabelUnit = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 10)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('bpm');
  const yAxisRMSSDLabel = svg
    .append('text')
    .attr('x', width - margin.right - 20)
    .attr('y', margin.top - 30)
    .style('font-size', '18px')
    .attr('font-weight', '100')
    .text('rmssd');
  const yAxisRMSSDLabelUnit = svg
    .append('text')
    .attr('x', width - margin.right)
    .attr('y', margin.top - 10)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('msec');
  // const g = svg
  //   .append('g')
  //   .selectAll('g')
  //   .data(data)
  //   .join('g')
  //   .attr('transform', (d) => `translate(${x(d.date) + 11},0)`);

  const gLegend = svg.append('g').attr('transform', (d) => `translate(550,${margin.top - 40})`);
  const RMSSDLegend = gLegend.append('circle').attr('cx', 180).attr('cy', 10).attr('r', 2).attr('fill', RMSSD_COLOR);
  const RMSSDLegendRect = gLegend
    .append('line')
    .attr('y1', 10)
    .attr('y2', 10)
    .attr('x1', 170)
    .attr('x2', 190)
    .attr('stroke-width', 1)
    .attr('stroke', RMSSD_COLOR);
  const RMSSDLegendText = gLegend
    .append('text')
    .attr('x', 200)
    .attr('y', 15)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('RMSSD');
  const PulseRateLegend = gLegend
    .append('circle')
    .attr('cx', 0)
    .attr('cy', 10)
    .attr('r', 2)
    .attr('fill', PULSE_RATE_COLOR);
  const PulseRateLegendLine = gLegend
    .append('line')
    .attr('y1', 10)
    .attr('y2', 10)
    .attr('x1', -10)
    .attr('x2', 10)
    .attr('stroke-width', 1)
    .attr('stroke', PULSE_RATE_COLOR);
  const PulseRateLegendText = gLegend
    .append('text')
    .attr('x', 20)
    .attr('y', 15)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Pulse Rate');

  return svg.node();
};